module.exports = __webpack_public_path__ + "assets/GoldEpsilon.d9754cfdc7208300aba3fdb1f696adf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldEpsilon.png
// module id = 760
// module chunks = 0